import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { formatDateAndTime } from '@marvelapp/core';
import { CopyToClipboardButton } from '../CopyToClipboadButton';
export const DateCell = observer(function DateCell({ value }) {
    const { date: formattedDate } = formatDateAndTime(new Date(value));
    return (_jsxs("div", { children: [formattedDate, _jsx(CopyToClipboardButton, { text: formattedDate })] }));
});
